// pages/ForgotPasswordPage.js
import React from "react";
import PasswordResetForm from "../components/PasswordResetForm";

const ForgotPasswordPage = () => {
  return (
    <div>
      <PasswordResetForm />
    </div>
  );
};

export default ForgotPasswordPage;
